import { render, staticRenderFns } from "./PViewerLayout.vue?vue&type=template&id=7269fbc8&scoped=true"
import script from "./PViewerLayout.vue?vue&type=script&lang=js"
export * from "./PViewerLayout.vue?vue&type=script&lang=js"
import style0 from "./PViewerLayout.vue?vue&type=style&index=0&id=7269fbc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7269fbc8",
  null
  
)

export default component.exports